<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-snackbar
      v-model="snackbar"
      xs12
      multi-line
      :timeout="timeout"
      top
      color="orange"
    >
      {{ alertmessage }}
      <v-btn
        color="white"
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <sequential-entrance from-top>
      <v-row>
        <v-col>
          <base-material-card
            color="primary"
            icon="mdi-checkbook"
            inline
          >
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">
                Send Checks for group {{ sitedetails }}
              </div>
              <div class="display-2 font-weight-light">
                Balance Available {{ groupbalance }}
              </div>
            </template>
            <v-data-table
              :headers="headers"
              :items="getchecks"
              sort-by="username"
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar
                  flat
                  color="white"
                >
                  <v-toolbar-title>Checks Issued</v-toolbar-title>

                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  />
                  <v-spacer />
                  <v-dialog
                    v-model="dialog"
                    max-width="500px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="warning"
                        dark
                        class="mb-2"
                        to="/Paymentactions"
                      >
                        Return
                      </v-btn><v-btn
                        color="primary"
                        dark
                        class="mb-2 mr-4"
                        v-on="on"
                      >
                        Issue New Check
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                            >
                              <v-text-field
                                v-model="editedItem.Company"
                                label="Company Name"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="editedItem.Amount"
                                label="Amount"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="6"
                            >
                              <v-dialog
                                ref="dialog"
                                v-model="modal"
                                :return-value.sync="editedItem.ChequePaymentDate"
                                persistent
                                width="290px"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-text-field
                                    v-model="editedItem.ChequePaymentDate"
                                    label="Check Issue Date"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                  />
                                </template>
                                <v-date-picker
                                  v-model="editedItem.ChequePaymentDate"
                                  scrollable
                                >
                                  <v-spacer />
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="modal = false"
                                  >
                                    Cancel
                                  </v-btn>
                                  <v-btn
                                    text
                                    color="primary"
                                    @click="$refs.dialog.save(editedItem.ChequePaymentDate)"
                                  >
                                    OK
                                  </v-btn>
                                </v-date-picker>
                              </v-dialog>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="editedItem.Address"
                                label="Address"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="editedItem.City"
                                label="City"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="6"
                            >
                              <v-select
                                v-model="editedItem.StateCode"
                                :items="getstates"
                                label="State"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="editedItem.Zip"
                                label="Zip"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="editedItem.Phone"
                                label="Phone"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="6"
                            >
                              <v-radio-group
                                v-model="editedItem.SendBy"
                                row
                              >
                                <v-radio
                                  label="Mail"
                                  value="Mail"
                                />
                                <v-radio
                                  label="FedEx"
                                  value="FedEx"
                                />
                              </v-radio-group>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="editedItem.Memo"
                                label="Memo"
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="6"
                            >
                              <v-text-field
                                v-model="editedItem.MessageOnCheck"
                                label="Message"
                              />
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="close"
                        >
                          Cancel
                        </v-btn>
                        <v-btn
                          color="blue darken-1"
                          :disabled="!formIsValid"
                          text
                          @click="save"
                        >
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:item.action="{ item }">
                <v-icon

                  color="primary"
                  size="20"
                  @click="editItem(item)"
                >
                  mdi-square-edit-outline
                </v-icon>
                <v-icon
                  color="black"
                  size="20"
                  class="ma-4"
                  @click="deleteItem(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
              <template v-slot:no-data>
                Sorry, No checks to display
              </template>
            </v-data-table>
          </base-material-card>

          <div class="py-3" />
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>

<script>
  import moment from 'moment'
  var numeral = require('numeral')

  export default {
    name: 'Depositusersbysite',
    props: ['id'],
    data: () => ({
      dialog: false,
      sitedetails: '',
      snackbar: false,
      modal: false,
      timeout: 5000,
      alertmessage: '',
      must_exist: [
        v => !!v || 'Please Enter a value'
      ],
      numeric_only: [
        // v => !!v || 'Please set empty fields to 0',
        v => /^[0-9]*$/.test(v) || 'Numeric values only',
      ],
      headers: [
        { text: 'Check Number', align: 'center', value: 'checknum' },
        { text: 'Ref ID', align: 'center', value: 'refid' },
        { text: 'Recipient', align: 'center', value: 'recipient' },
        { text: 'Date Issued', align: 'center', value: 'issued' },
        { text: 'Amount', align: 'center', value: 'amount' },
        { text: 'Status', align: 'center', value: 'status' },
      ],
      alerts: [],
      depositusers: [],
      typeList: ['Standard', 'Cit'],
      editedIndex: -1,
      editedItem: {
        Company: '',
        FirstName: '',
        LastName: '',
        Address: '',
        City: '',
        State: '',
        StateCode: '',
        Zip: '',
        CountryCode: 'US',
        RefID: '',
        Phone: '',
        Amount: '',
        SendBy: '',
        Memo: '',
        CheckNumber: '',
        ChequePaymentDate: '',
        MessageOnCheck: '',
        MerchantTransID: '',
      },
      defaultItem: {
        Company: '',
        FirstName: '',
        LastName: '',
        Address: '',
        City: '',
        State: '',
        StateCode: '',
        Zip: '',
        CountryCode: '',
        RefID: '',
        Phone: '',
        Amount: '',
        SendBy: '',
        Memo: '',
        CheckNumber: '',
        ChequePaymentDate: '',
        MessageOnCheck: '',
        MerchantTransID: '',
      },
    }),

    computed: {
      formIsValid () {
        return true
      },
      groupsafesOnline () {
        return '1'
      },
      groupbalance () {
        let gbal = 0.01 // float
        gbal = this.$store.getters.getGroupBalance
        return numeral(gbal).format('$0.00')
      },
      formTitle () {
        return this.editedIndex === -1 ? 'Issue New Check' : 'Edit Check'
      },
      getalerts () {
        this.alerts = this.$store.getters.alerts
        return this.alerts
      },
      getstates () {
        let state_hash = [
          'AL',
          'AK',
          'AS',
          'AZ',
          'AR',
          'CA',
          'CO',
          'CT',
          'DE',
          'DC',
          'FM',
          'FL',
          'GA',
          'GU',
          'HI',
          'ID',
          'IL',
          'IN',
          'IA',
          'KS',
          'KY',
          'LA',
          'ME',
          'MH',
          'MD',
          'MA',
          'MI',
          'MN',
          'MS',
          'MO',
          'MT',
          'NE',
          'NV',
          'NH',
          'NJ',
          'NM',
          'NY',
          'NC',
          'ND',
          'MP',
          'OH',
          'OK',
          'OR',
          'PW',
          'PA',
          'PR',
          'RI',
          'SC',
          'SD',
          'TN',
          'TX',
          'UT',
          'VT',
          'VI',
          'VA',
          'WA',
          'WV',
          'WI',
          'WY'
        ]
        return state_hash
      },
      getchecks () {
        // get checks for the current group
        return []
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      console.log(this.$route.params.id)
      this.sitedetails = this.$route.params.id
      this.$log.debug('LOADING THIS ID ', this.$route.params.id)
      this.editedItem.ChequePaymentDate = new Date().toISOString().substr(0, 10)
      this.editedItem.SendBy = 'Mail'
      let group = this.$route.params.id
      console.log(this.editedItem.Company)
      this.$store.dispatch('createWalletBalanceRequest', group)

      this.initialize()
    },

    methods: {
      initialize () {
        this.alerts = this.$store.getters.alerts
        this.depositusers = this.$store.getters.depositusers
      },
      editItem (item) {
        this.editedIndex = this.depositusers.indexOf(item)
        this.$log.debug('edited index is ', this.editedIndex, 'edited item was ', item, 'alerts array is ', this.depositusers)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
      deleteItem (item) {
        const index = this.depositusers.indexOf(item)
        this.$log.debug('site info is ', item)
        if (confirm('Are you sure you want to delete this item?') && this.depositusers.splice(index, 1)) {
          this.$log.debug('site info is ', item.key)
          let rec = {
            key: item.key,
            siteid: this.sitedetails.idnum
          }
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
      onChange (value) {
        this.$refs.menu.save(value)
        this.$log.debug('value passed to on change function ', value)
        let newdate = moment(value, 'YYYY-MM-DD')
        this.editedItem.ChequePaymentDate = newdate
      },
      save () {
        // check to see if the pin is unique
        if (this.editedIndex > -1) {
          // we dont edit these
          // this.$store.dispatch('updateChangeProfile', this.editedItem)
        } else {
          console.log(this.editedItem)
          console.log(this.sitedetails)
          let rec = {
            sitedetails: this.sitedetails,
            userdetails: this.user,
            timestamp: Date.now(),
            checkrequest: this.editedItem
          }
          // site details
          // safe id
          // user details
          // timestamp
          this.$store.dispatch('createCheckRequest', rec)
        }
        this.close()
      },
    },
  }
</script>
